// lib
import { connect } from 'react-redux';

// component
import Product from './Product';

// redux selectors
import { getRemoteConfig } from 'shared/store/remoteConfigs/selectors';

const mapStateToProps = (state: any) => {
  const isFloatingTags = getRemoteConfig(state, 'product_tags_floating');

  return { isFloatingTags };
};

export default connect(mapStateToProps)(Product);
